import React, { useEffect, useState } from "react";
import { collection, getDocs, doc, deleteDoc } from "firebase/firestore";
import { db } from "./Firebase";
import FirestoreTable from "./FirestoreTableApp";
import styled, { keyframes } from "styled-components";
import * as XLSX from "xlsx";
import ContratoPDF from "./ContratoPDF";

const ContenedorDiv = styled.div`
  display: flex;
  margin: 0px 5rem 10px 5rem;
  max-height: 24rem;
  justify-content: space-evenly;
  flex-direction: column;
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    margin: 0px 1rem 10px 1rem;
    max-height: 25rem;
  }
`;
const LoadingDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin: auto;
  p {
    margin: 0px;
  }
`;
const Loading = keyframes`
    0% {
      width: 0px;
    }
    100% {
      width: 100%;
    }
  `;
const LoadingLine = styled.div`
  width: 100%;
  height: 2px;
  background-color: #c20000;
  border-radius: 2px;
  animation: ${Loading} 3s infinite linear;
`;
const EstiloButton = styled.button`
  margin-bottom: 10px;
  background-color: #6a6e73;
  color: white;
  padding: 3x;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  text-decoration: none;
  &:hover {
    background-color: rgb(41, 41, 41);
    transition: 0.3s;
  }
`;
const BotonGenerarPDF = styled.button`
  width: 100px;
  background-color: #6a6e73;
  color: white;
  padding: 3px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  text-decoration: none;
  &:hover {
    background-color: rgb(41, 41, 41);
    transition: 0.3s;
  }
`;

function FirestoreTableContrato() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const querySnapshot = await getDocs(collection(db, "contratos"));
      let data = querySnapshot.docs.map((doc) => {
        return {
          ...doc.data(),
          docId: doc.id,
          fechaOriginal: new Date(doc.data().fecha),
        };
      });
      // Ordenar los datos por fechaOriginal de más reciente a más antiguo
      data.sort((a, b) => b.fechaOriginal - a.fechaOriginal);
      setData(data);
      setLoading(false);
    };
    fetchData();
  }, []);

  const deleteRow = async (docId) => {
    if (docId) {
      const docRef = doc(db, "contratos", docId);
      await deleteDoc(docRef);
      // Actualizar los datos
      setData(data.filter((item) => item.docId !== docId));
    } else {
      console.error("Error: Intentando eliminar un documento con una ID vacía");
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Descargar PDF",
        accessor: "docId",
        Cell: ({ row }) => {
          const [pdfVisible, setPdfVisible] = useState(false);

          return (
            <>
              {/* Si pdfVisible es false, muestra el botón; si es true, muestra el PDF */}
              {!pdfVisible ? (
                <BotonGenerarPDF onClick={() => setPdfVisible(true)}>
                  Generar PDF
                </BotonGenerarPDF>
              ) : (
                <ContratoPDF
                  contratoData={row.original}
                  pdfVisible={pdfVisible}
                />
              )}
            </>
          );
        },
      },
      {
        Header: "Contrato",
        accessor: "fecha",
        Cell: ({ value }) => formatFecha(value),
      },
      { Header: "Código", accessor: "contratoNumero" },
      { Header: "Cliente", accessor: "nombreApellido" },
      { Header: "DNI", accessor: "dni" },
      { Header: "Bus", accessor: "tipoBus" },
      { Header: "Pisos", accessor: "pisos" },
      { Header: "Butacas", accessor: "butacas" },
      {
        Header: "Salida",
        accessor: "fechaSalida",
        Cell: ({ value }) => formatFecha(value),
      },
      { Header: "Desde", accessor: "origen" },
      { Header: "Hasta.", accessor: "destino" },
      {
        Header: "Regreso",
        accessor: "fechaRegreso",
        Cell: ({ value }) => formatFecha(value),
      },
      { Header: "Tarifa", accessor: "tarifaTotal" },
    ],
    []
  );

  // Función para formatear fechas en "dd/mm/aaaa"
  const formatFecha = (fecha) => {
    if (!fecha) return ""; // Manejar valores vacíos o undefined
    return new Date(
      new Date(fecha).toLocaleString("en-US", {
        timeZone: "UTC",
      })
    ).toLocaleDateString("es-ES");
  };

  const generarPlanilla = () => {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Contratos");

    const nombrePlanilla = `ContratosServiciosEspeciales.xlsx`;

    XLSX.writeFile(workbook, nombrePlanilla);
  };

  return (
    <div style={{ textAlign: "center" }}>
      <h4>Contratos</h4>
      <ContenedorDiv>
        {loading ? (
          <LoadingDiv>
            <p>Cargando datos...</p>
            <LoadingLine></LoadingLine>
          </LoadingDiv>
        ) : (
          <FirestoreTable columns={columns} data={data} deleteRow={deleteRow} />
        )}
      </ContenedorDiv>
      <EstiloButton onClick={generarPlanilla}>Generar Planilla</EstiloButton>
    </div>
  );
}

export default FirestoreTableContrato;
export { BotonGenerarPDF };
